<h3 mat-dialog-title class="aza-pa-dialog-title">{{ data.title }}</h3>
<div mat-dialog-content class="aza-pa-dialog-content">
    <div class="aza-pa-flex-row aza-pa-content-center">
        <mat-spinner></mat-spinner>
    </div>
</div>
